import React, {useEffect, useState} from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/JobDetail.css";
import {Link, useParams} from "react-router-dom";
import {connect} from "react-redux";
import {GetBookingsAction} from "../../redux/actions/bookings";
import config from "../../config";
import moment from "moment";
import JobButtons from "../../components/JobButtons";
import Swal from "sweetalert2";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import {START_LOADER, STOP_LOADER} from "../../redux/actions/types";
import Pusher from "pusher-js";

let pusher = null;

function JobDetail({auth, startLoading, stopLoading}) {
    const [job, setJob] = useState();
    const [loading, setLoading] = useState(true);
    const [rating, setRating] = useState(0);
    const [reviewText, setReviewText] = useState("");
    const [reviewModal, setReviewModal] = useState(false);
    const [changeTimeModal, setChangeTimeModal] = useState(false);
    const [changingTimeOfScheduleId, setChangingTimeOfScheduleId] =
        useState(null);

    const [changingStartTime, setChangingStartTime] = useState(null);
    const [changingEndTime, setChangingEndTime] = useState(null);

    let {id} = useParams();
    console.log("useParams ",id);

    const getJob = () => {
        const headers = config.bearerHeaders(auth.token);
        config.getApi(config.services.singleJob(id), headers).then((res) => {
            if (res) {
                setJob(res.response.data);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        getJob();
        pusher = new Pusher(config.pusher.key, {
            cluster: config.pusher.cluster,
        });
        let channel = pusher.subscribe("job");
        channel.bind("pusher:subscription_succeeded", () => {
            channel.bind("App\\Events\\JobEvent", (e) => {
                // let newJob = e.message.job;
                getJob();
            });
        });
        // return () => {
        //     channel.unbind_all();
        // };
    }, []);

    const review = async () => {
        try {
            setReviewModal(false);
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.postApi(
                config.services.rate(),
                headers,
                JSON.stringify({
                    user_id: auth.user.id,
                    care_giver_id:
                        auth.user.id == job.care_giver_id
                            ? job.user_id
                            : job.care_giver_id,
                    job_id: job.id,
                    type: 1,
                    rating: rating,
                    comment: reviewText,
                })
            );
            stopLoading();
            if (res) {
                getJob();
                Swal.fire({
                    icon: "success",
                    title: "Rate",
                    text: "Rated Successfully!",
                });
            }
        } catch (e) {
            stopLoading();
            console.log(e);
        }
    };

    const startJob = async (schedule_id) => {
        try {
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(
                config.services.startJob(id, schedule_id),
                headers
            );
            stopLoading();
            if ( res ) {
                Swal.fire({
                    icon: "success",
                    title: "Job",
                    text: "Job Started!",
                });
                getJob();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const startJobCustomer = async (schedule_id) => {
        try {
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(
                config.services.startJobCustomer(id, schedule_id),
                headers
            );
            stopLoading();
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Job",
                    text: "Job Started!",
                });
                getJob();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const acceptJob = async ( schedule_id ) => {
        try {
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(
                config.services.acceptJob(id, schedule_id),
                headers
            );
            stopLoading();
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Job",
                    text: "Job Accepted!",
                });
                getJob();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const cancelScheduleJob = async ( schedule_id ) => {
        try {
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(
                config.services.cancelScheduleJob(id, schedule_id),
                headers
            );
            stopLoading();
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Job",
                    text: "Job Canceled!",
                });
                getJob();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const endJob = async (schedule_id) => {
        try {
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(
                config.services.endJob(id, schedule_id),
                headers
            );
            stopLoading();
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Job",
                    text: "Job Ended!",
                });
                getJob();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const changeTime = async () => {
        try {
            setChangeTimeModal(false);
            let data = JSON.stringify({
                start_time: changingStartTime,
                end_time: changingEndTime,
            });
            let schedule_id = changingTimeOfScheduleId;
            startLoading();
            let res = await config.postApi(
                config.services.updateTime(id, schedule_id),
                config.bearerHeaders(auth.token),
                data
            );
            setChangingStartTime(null);
            setChangingEndTime(null);
            setChangingTimeOfScheduleId(null);
            stopLoading();
            if (res) {
                Swal.fire({
                    title: "Time Updated!",
                    text: `Time has been changed`,
                });
                getJob();
            }
        } catch (e) {
            stopLoading();
            console.log(e);
        }
    };

    if (loading) {
        return <div/>;
    }

    let jobStatusColor = "#ff8800";
    if (job.status == config.jobConstants.ACCEPTED) {
        jobStatusColor = "blue";
    } else if (job.status == config.jobConstants.PROGRESS) {
        jobStatusColor = "green";
    }

    console.log("Job", job);

    return (
        <>
            <Header/>
            <section className="job_detail">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="full_booking_detail">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="heading_wrapper heading_wrapper pb-2">
                                            <div className="booking_id">
                                                <p>Booking Id ({job.id})</p>
                                            </div>
                                            <div className="name">
                                                <h4>{job.title}</h4>
                                            </div>
                                        </div>
                                        <div className="about_profile">
                                            <div className="care_giver">
                                                <div className="img_box">
                                                    <figure>
                                                        <img
                                                            src={
                                                                job.user_id ==
                                                                auth.user.id
                                                                    ? config.returnImage(
                                                                        job.care_giver
                                                                    )
                                                                    : config.returnImage(
                                                                        job.user
                                                                    )
                                                            }
                                                            alt=""
                                                        />
                                                    </figure>
                                                    <div className="name">
                                                        <h6 className="care_giver_name">
                                                            {job.user_id ==
                                                            auth.user.id
                                                                ? job.care_giver
                                                                    .full_name
                                                                : job.user
                                                                    .full_name}
                                                        </h6>
                                                        <span className="type">
                                                            {job.user_id ==
                                                            auth.user.id
                                                                ? "Care Giver"
                                                                : "Client"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="rating">
                                                    <p>
                                                        <i
                                                            className="fa fa-star"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        {job.user_id ==
                                                        auth.user.id
                                                            ? job.care_giver
                                                                .rating_by_customer
                                                            : job.user
                                                                .rating_by_customer}
                                                    </p>
                                                </div>
                                            </div>
                                            <ul className="all_details">
                                                <li>
                                                    <i
                                                        className="fa fa-usd"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    <span>${job.amount} </span>(
                                                    {job.total_time} Hours)
                                                </li>
                                                <li>
                                                    <i
                                                        className="fa fa-calendar-o"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    {moment(
                                                        job.created_at
                                                    ).format("DD MMMM, YYYY")}
                                                </li>
                                                <li>
                                                    <i
                                                        className="fa fa-clock-o"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    {moment(
                                                        job.created_at
                                                    ).format("hh : mm A")}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button-group">
                                            {auth.user.id == job.user_id &&
                                                job.status == "Completed" &&
                                                job.caregiver_rating ==
                                                null && (
                                                    <button
                                                        type="button"
                                                        className="btn"
                                                        // to={`/review/${
                                                        //     job.user.id ==
                                                        //     auth.user.id
                                                        //         ? job.care_giver.id
                                                        //         : job.user.id
                                                        // }`}
                                                        onClick={() =>
                                                            setReviewModal(true)
                                                        }
                                                    >
                                                        Review
                                                    </button>
                                                )}
                                            <Link
                                                className="btn"
                                                to={`/all-chat/${
                                                    job.user.id == auth.user.id
                                                        ? job.care_giver.id
                                                        : job.user.id
                                                }`}
                                            >
                                                <i
                                                    className="fa fa-comment-o"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Chat Now
                                            </Link>
                                        </div>
                                        <div className="status">
                                            <p>
                                                <img
                                                    src="img/note.png"
                                                    alt=""
                                                />{" "}
                                                <span
                                                    style={{
                                                        color: jobStatusColor,
                                                    }}
                                                >
                                                    {job.status}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom_bar">
                                    <div className="addressDv">
                                        <p>
                                            <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            {job.destination_address + " "}
                                            <Link
                                                to={`/tracking-job/${job.id}`}
                                            >
                                                View on Map
                                            </Link>
                                        </p>
                                    </div>
                                    {/* <div className="remaining_time">
                                        <p>
                                            Time Remaining{" "}
                                            <span className="time">
                                                1 Days | 05 Hours | 57 Mins
                                            </span>
                                        </p>
                                    </div> */}
                                </div>
                            </div>

                            {job.caregiver_rating?.rating > 0 && (
                                <div className="description_box">
                                    <h4>Rating &amp; Review</h4>
                                    <div className="rating_dv">
                                        {/* <label>Rating</label> */}
                                        <div className="raings_stars">
                                            <div className="stars-group">
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        parseInt(
                                                            job.caregiver_rating
                                                                .rating
                                                        ) >= 1
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        parseInt(
                                                            job.caregiver_rating
                                                                .rating
                                                        ) >= 2
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        parseInt(
                                                            job.caregiver_rating
                                                                .rating
                                                        ) >= 3
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        parseInt(
                                                            job.caregiver_rating
                                                                .rating
                                                        ) >= 4
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        parseInt(
                                                            job.caregiver_rating
                                                                .rating
                                                        ) >= 5
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {job.caregiver_rating.comment}
                                </div>
                            )}

                            <div className="description_box">
                                <h4>Description</h4>
                                <p>{job.note}</p>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="visit_box">
                                        {Object.keys(job.schedule).map(
                                            (schedule_date) => {
                                                return (
                                                    <div key={schedule_date}>
                                                        <div className="date">
                                                            <h5>
                                                                {moment(
                                                                    schedule_date
                                                                ).format(
                                                                    "dddd, DD MMMM"
                                                                ) + " "}
                                                            </h5>
                                                        </div>
                                                        {job.schedule[
                                                            schedule_date
                                                            ].map(
                                                            (
                                                                singleSchedule
                                                            ) => (
                                                                <div
                                                                    className="visitingDv"
                                                                    key={
                                                                        "schedule_" +
                                                                        singleSchedule.id.toString()
                                                                    }
                                                                >
                                                                    <div className="form-group">
                                                                        {/* <h5>
                                                                            First
                                                                            Visit
                                                                        </h5> */}
                                                                        <div className="inputs_group">
                                                                            <div className="inputs">
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Start
                                                                                        Time
                                                                                    </label>
                                                                                    <input
                                                                                        type="time"
                                                                                        readOnly
                                                                                        value={moment(
                                                                                            singleSchedule.job_date +
                                                                                            " " +
                                                                                            singleSchedule.start_time
                                                                                        ).format(
                                                                                            "HH:mm"
                                                                                        )}
                                                                                        className="form-control"
                                                                                    />
                                                                                </div>
                                                                                <span>
                                                                                    -
                                                                                </span>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        End
                                                                                        Time
                                                                                    </label>
                                                                                    <input
                                                                                        type="time"
                                                                                        readOnly
                                                                                        value={moment(
                                                                                            singleSchedule.job_date +
                                                                                            " " +
                                                                                            singleSchedule.end_time
                                                                                        ).format(
                                                                                            "HH:mm"
                                                                                        )}
                                                                                        className="form-control"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <span className="m-2">
                                                                                $
                                                                                {
                                                                                    singleSchedule.amount
                                                                                }
                                                                            </span>

                                                                            <div>
                                                                                <JobButtons
                                                                                    job_status={
                                                                                        job.status
                                                                                    }
                                                                                    often={job?.often}
                                                                                    customer_id={
                                                                                        job.user_id
                                                                                    }
                                                                                    care_giver_id={
                                                                                        job.care_giver_id
                                                                                    }
                                                                                    acceptJob={
                                                                                        acceptJob
                                                                                    }
                                                                                    cancelScheduleJob={cancelScheduleJob}
                                                                                    endJob={
                                                                                        endJob
                                                                                    }
                                                                                    startJob={
                                                                                        startJob
                                                                                    }
                                                                                    startJobCustomer={
                                                                                        startJobCustomer
                                                                                    }
                                                                                    schedule_id={
                                                                                        singleSchedule.id
                                                                                    }
                                                                                    status={
                                                                                        singleSchedule.status
                                                                                    }
                                                                                    schedule={
                                                                                        singleSchedule
                                                                                    }
                                                                                    onChangeTime={(
                                                                                        id
                                                                                    ) => {
                                                                                        setChangeTimeModal(
                                                                                            true
                                                                                        );
                                                                                        setChangingTimeOfScheduleId(
                                                                                            id
                                                                                        );
                                                                                        setChangingStartTime(
                                                                                            singleSchedule.start_time
                                                                                        );
                                                                                        setChangingEndTime(
                                                                                            singleSchedule.end_time
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            singleSchedule.status
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="client_details">
                                        <div className="heading">
                                            <h4>Client Details</h4>
                                        </div>
                                        <ul className="details">
                                            <li>
                                                <h5 className="property">
                                                    Full Name of Client
                                                </h5>
                                                <h5 className="value">
                                                    {job.full_name}
                                                </h5>
                                            </li>
                                            <li>
                                                <h5 className="property">
                                                    Gender
                                                </h5>
                                                <h5 className="value">
                                                    {job.gender == 0
                                                        ? "Male"
                                                        : job.gender == 1
                                                            ? "Female"
                                                            : job.gender}
                                                </h5>
                                            </li>
                                        </ul>
                                        <div className="detail_about_person mt-4">
                                            <h5>
                                                Details About the Person who is
                                                directly getting service
                                            </h5>
                                            <p>{job.client_identity}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="client-box">
                                <div className="img_box">
                                    <figure>
                                        <img src="img/client.png" alt=""/>
                                    </figure>
                                </div>
                                <div className="about_client">
                                    <h5 className="name">
                                        {job.user_id == auth.user.id
                                            ? job.care_giver.full_name
                                            : job.user.full_name}
                                    </h5>
                                    <span className="type">Client</span>
                                    <p className="member_since">
                                        Member Since -{" "}
                                        {job.user_id == auth.user.id
                                            ? moment(
                                                job.care_giver.created_at
                                            ).format("MMM YYYY")
                                            : moment(
                                                job.user.created_at
                                            ).format("MMM YYYY")}
                                    </p>
                                </div>
                                <div className="address">
                                    <p className="location">
                                        <i
                                            className="fa fa-map-marker"
                                            aria-hidden="true"
                                        ></i>{" "}
                                        {job.user_id == auth.user.id
                                            ? `${job.care_giver.city} ${job.care_giver.country}`
                                            : `${job.user.city} ${job.user.country}`}
                                    </p>
                                    <p>
                                        {job.user_id == auth.user.id
                                            ? job.care_giver.bio
                                            : job.user.bio}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal
                show={reviewModal}
                size="lg"
                onHide={() => {
                    setReviewModal(false);
                }}
            >
                <ModalHeader closeButton>
                    <Modal.Title>Rate {job.care_giver.full_name}</Modal.Title>
                </ModalHeader>
                <ModalBody>
                    <div className="rating_dv">
                        <label>Rating</label>
                        <div className="raings_stars">
                            <div className="stars-group">
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color={rating >= 1 ? "#FFCC00" : "#C8C8C8"}
                                    onClick={() => setRating(1)}
                                    size={"lg"}
                                />
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color={rating >= 2 ? "#FFCC00" : "#C8C8C8"}
                                    onClick={() => setRating(2)}
                                    size={"lg"}
                                />
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color={rating >= 3 ? "#FFCC00" : "#C8C8C8"}
                                    onClick={() => setRating(3)}
                                    size={"lg"}
                                />
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color={rating >= 4 ? "#FFCC00" : "#C8C8C8"}
                                    onClick={() => setRating(4)}
                                    size={"lg"}
                                />
                                <FontAwesomeIcon
                                    icon={faStar}
                                    color={rating >= 5 ? "#FFCC00" : "#C8C8C8"}
                                    onClick={() => setRating(5)}
                                    size={"lg"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group mt-4">
                        <label>Review</label>
                        <textarea
                            placeholder="Review"
                            className="form-control"
                            value={reviewText}
                            onChange={(e) => setReviewText(e.target.value)}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => setReviewModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={review}
                    >
                        Rate
                    </button>
                </ModalFooter>
            </Modal>
            <Modal
                show={changeTimeModal}
                size="lg"
                onHide={() => {
                    setChangeTimeModal(false);
                    setChangingStartTime(null);
                    setChangingEndTime(null);
                    setChangingTimeOfScheduleId(null);
                }}
            >
                <ModalHeader closeButton>
                    <Modal.Title>Change Time</Modal.Title>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label htmlFor="start_time">Start Time</label>
                                <input
                                    type={"time"}
                                    className="form-control"
                                    id="start_time"
                                    value={changingStartTime}
                                    onChange={(e) =>
                                        setChangingStartTime(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label htmlFor="end_time">End Time</label>
                                <input
                                    type={"time"}
                                    className="form-control"
                                    id="end_time"
                                    value={changingEndTime}
                                    onChange={(e) =>
                                        setChangingEndTime(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                            setChangeTimeModal(false);
                            setChangingTimeOfScheduleId(null);
                            setChangingStartTime(null);
                            setChangingEndTime(null);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={changeTime}
                    >
                        Change
                    </button>
                </ModalFooter>
            </Modal>
            <Footer/>
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    getPendingBookings: async () =>
        dispatch(await GetBookingsAction("Pending")),
    getOngoingBookings: async () =>
        dispatch(await GetBookingsAction("Progress")),
    startLoading : () => dispatch({type: START_LOADER}),
    stopLoading : () => dispatch({type: STOP_LOADER}),
});

export default connect( mapStateToProps, mapDispatchToProps )( JobDetail );
